{
  "agecCompliance": {
    "complete": "<strong1>{{percent}}%</strong1> completion",
    "compliant": "{{count}} Compliant products, click <link1>here</link1> to see them",
    "label": "Compliant / Non compliant products",
    "nonCompliant": "{{count}} Non compliant products, click <link1>here</link1> to see them",
    "title": "AGEC law",
    "total": "<strong1>{{total}}</strong1> total",
    "totalText": "All imported products"
  },
  "documents": {
    "certificateType": "Type",
    "complete": "<strong1>{{percent}}%</strong1> completion",
    "label": "Verified / Pending certificates",
    "noDocuments": {
      "message": "Please launch a certificate campaign",
      "title": "No documents found"
    },
    "pending": "Pending",
    "title": "Certificates",
    "total": "<strong1>{{total}}</strong1> total",
    "totalText": "Verify pending certificates",
    "totalTextCompleted": "Congrats! All uploaded certificates have been validated",
    "verified": "Verified"
  },
  "informationRequests": {
    "activityTier": "Tiers",
    "average": "<strong1>{{days}} days</strong1> average completion delay",
    "closed": "Closed",
    "collection": "Collection",
    "complete": "<strong1>{{percent}}%</strong1> completion",
    "ingestionDate": "Ingestion date",
    "ingestionDateFilter": {
      "moreThanSixMonths": "More than 6 Months",
      "oneMonth": "Less than 1 Month",
      "oneToThreeMonths": "Between 1 and 3 Months",
      "threeToSixMonths": "Between 3 and 6 Months"
    },
    "label": "Opened / Closed requests",
    "noAverage": "No responses received",
    "noProducts": "No products",
    "noRequests": "No requests",
    "open": "Open",
    "title": "Requests",
    "total": "<strong1>{{total}}</strong1> requests",
    "totalText": "All the information requests sent to your suppliers including the transferred and canceled ones",
    "type": "Type"
  },
  "notifications": {
    "actions": {
      "copy": "Copy message",
      "markAsDone": "Finished"
    },
    "alerts": {
      "descriptions": {
        "expiredLaunchDate": "Commercialized products with partial traceability information",
        "incomingLaunchDate": "Pending information requests (due within 3 weeks)"
      }
    },
    "archived": {
      "success": "Notification archived"
    },
    "copy": {
      "messages": {
        "unanswered": "This is a kindly reminder that we need your help to progress on traceability through the Trace For Good platform. Missing information from you is blocking the process, but fortunately all we need from you is a few minutes of your time!<eol/><eol/><bold>If the email is in your mailbox</bold>, please follow the instructions.<eol/><eol/><bold>If the email is in your SPAM</bold>, please mark it as “not SPAM” and follow instructions.<eol/><eol/><bold>If the email is not in your SPAM</bold>, please follow the instructions below:<eol/>- Go to the page: https://app.traceforgood.com/login<eol/>- Click on “I am a supplier” and enter your email address<eol/>- Click on the link received by email to access the questionnaire.<eol/><eol/>For any questions or issues, please contact: support@traceforgood.com.<eol/>Thank you very much for your help.",
        "undelivery": "It seems that an email sent by the Trace For Good platform, the traceability software we use, could not be sent to you. As a reminder, getting these information from our suppliers is mandatory for us.<eol/><eol/><bold>If the email is in your SPAM</bold>, please mark it as “not SPAM” and follow instructions.<eol/><eol/><bold>If the email is not in your SPAM</bold>, please follow the instructions below:<eol/><eol/>- Go to the page: https://app.traceforgood.com/login<eol/>- Click on “I am a supplier” and enter your email address<eol/>- Click on the link received by email to access the questionnaire.<eol/><eol/>For any questions or issues, please contact: support@traceforgood.com.<eol/><eol/>Thank you in advance for your help."
      },
      "success": "Message copied to the clipboard",
      "title": "Copy message to clipboard"
    },
    "empty": {
      "alerts": "Congratulations! You have no alerts.",
      "completed": "None",
      "pending": "Congratulations! You managed all notifications."
    },
    "language": {
      "english": "English",
      "french": "French"
    },
    "tab": {
      "alerts": "Spotlights (beta)",
      "completed": "History",
      "pending": "To do"
    },
    "title": "Notifications",
    "traceability": {
      "deliverability": {
        "action": "Send the email manually",
        "cause": "Sent email could not be delivered"
      },
      "type": "Traceability",
      "unanswered": {
        "action": "Send a reminder manually",
        "cause": "The contact has open requests without an answer"
      }
    }
  }
}
